import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const DuplicateIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11zM8 21V7h6v5h5v9z"
    />
  </BaseIcon>
)
